import React, { useEffect, useRef, useState } from "react";
import DashboardSideBar from "../common/dashboardSideBar";
import SearchFlyer from "../common/searchFlyer";
import { Dropdown } from "react-bootstrap";
import algoliasearch from "algoliasearch";
import LoadingBar from "react-top-loading-bar";
import { getCount, logOut, unReadChatCount } from "../../../actions/memberAction";
import { Link, navigate } from "gatsby";
import Logo from "../../common/logo";
import { getMember, numberFormat } from "../../../actions/miscAction";
import useNCNDACheck from "../../common/customHooks/useNCNDACheck";
import NCNDAModal from "../../models/ncndaModal";
import _ from "lodash";
import * as styles from "../../../include/css/css-components/header/Header.module.css";
import CommonHeader from "../../common/commonHeader";
import ChatIcon from "../../common/chatIcon";
import { isMobile } from "react-device-detect";
import useScreenSize from "../../common/customHooks/useScreenSize";
import Help from "../../common/help/help";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

const Header = () => {
  const ref = useRef();
  const { width, height } = useScreenSize();
  let timeoutId = null;
  const [showSideBar, setShowSideBar] = useState(false);
  const [displaySearchOnMobile, setDisplaySearchOnMobile] = useState(false);
  const [querydata, setQuerydata] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [facets, setFacets] = useState(null);
  const [dashboardCount, setDashboardCount] = useState(null);
  const [mimic, setMimic] = useState(
    typeof window !== "undefined" && localStorage.getItem("mimictoken") ? true : false,
  );
  const [unreadCount, setUnreadCount] = useState(0);
  const [showHelp, setShowHelp] = useState(false);

  const toggleHelp = () => {
    setShowHelp((prev) => !prev);
  };

  const member = getMember();

  useEffect(() => {
    if (mimic) {
      document.body.classList.add("has-top-header", "new-body-padding-top-mimic");
    } else {
      document.body.classList.remove("has-top-header", "new-body-padding-top-mimic");
    }
  }, [mimic]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const root = document.documentElement;
      const brnadColor = getComputedStyle(root).getPropertyValue("--brand-color1").trim();

      if (!brnadColor) {
        const updateThemeColors = (newColors) => {
          if (typeof window !== "undefined") {
            Object.keys(newColors).forEach((key) => {
              document.documentElement.style.setProperty(`--${key}`, newColors[key]);
            });
          }
        };

        // Example usage: Change theme colors dynamically
        const newTheme = {
          "brand-color1": "#227300", // New primary color
          "brand-color2": "#47AD1D",
          "brand-color3": "#ccecf8",
          "btn-text-color1": "#FFF",
          "btn-text-color2": "#FFF",
          "btn-text-color3": "#000",
        };

        updateThemeColors(newTheme);
      }
    }
  }, []);

  //Loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loading && member) {
      setLoading(false);
      getCount((res) => {
        if (res.status === 200) {
          setDashboardCount(res.data);
        }
      });
    }
  }, [loading]);

  const toggleSideBar = () => {
    setShowSideBar(!showSideBar);
  };

  const onChangeInput = (e) => {
    const value = e.target.value;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(async () => {
      setQuerydata(value);

      if (value.trim() !== "") {
        // Only search if there's input
        const records = await index.search(value, {
          facets: ["categories.lvl0", "make", "region"],
          hitsPerPage: 1,
        });

        setFacets(records.facets);
        setShowSearch(true);
      } else {
        setShowSearch(false);
      }
    }, 300);
  };

  const onLogOut = () => {
    ref?.current?.continuousStart();
    logOut((res) => {
      if (res && res.status == 200) {
        ref?.current?.complete();
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          window.location.href = "/";
        }
      } else {
        ref?.current?.complete();
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          window.location.href = "/";
        }
      }
    });
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.body.classList.add("new-body-padding-top");
      if (member?.name01 && width > 1200) {
        document.body.classList.add("new-header-login");
      }
      if (mimic) {
        document.body.classList.add("new-body-padding-top-mimic");
      }
      if (displaySearchOnMobile) {
        document.body.classList.add("search-box-open");
      }
      return () => {
        document.body.classList.remove("search-box-open");
        document.body.classList.remove("new-body-padding-top-mimic");
        document.body.classList.remove("new-body-padding-top");
        document.body.classList.remove("new-header-login");
      };
    }
  }, [displaySearchOnMobile, width]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        const isLocalStorageAvailable = !!localStorage;
        if (isLocalStorageAvailable) {
          setLoading(false);
        }
      } catch (error) {
        console.error("LocalStorage is not available:", error);
      }
    }
  }, []);

  const getUnreadChatCount = () => {
    unReadChatCount((res) => {
      setUnreadCount(res?.data?.data);
    });
  };

  useEffect(() => {
    if (member?.name01) {
      getUnreadChatCount();
    }
  }, [member?.name01]);

  const customizedDashboard = typeof window !== "undefined" && JSON.parse(localStorage.getItem("customization"));

  const { showNCNDA, toggleNCNDA } = useNCNDACheck();

  return (
    <>
      <LoadingBar color="var(--brand-color2)" ref={ref} />

      <header id="brandHeader">
        <div className="nl-common-header">
          <CommonHeader toggleHelp={toggleHelp} />
        </div>
        <div className="header-main-container">
          <nav className="navbar navbar-expand-xl">
            <div
              className="container-fluid"
              style={{ paddingRight: "0px", paddingLeft: displaySearchOnMobile ? "0px" : "" }}
            >
              <div className="nav-inside position-relative flex-wrap d-flex align-items-center">
                <Logo newHeader={true} />
                <button
                  className={`nav-icon nl-nav-icon ${isMobile && mimic ? "nl-nav-icon-mimic" : ""} ${
                    displaySearchOnMobile ? "nl-static" : ""
                  }`}
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#categoriesCollapse"
                  onClick={toggleSideBar}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
                <div className="navbar-collapse flex-grow-0 d-none d-xl-block">
                  <div className="navbar-inside ml-auto">
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <a className="nav-link" href="/categories">
                          Categories
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="/manufacturers">
                          Manufacturers
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="/regions">
                          Regions
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="search-box-icon d-xl-none d-flex">
                  {!displaySearchOnMobile ? (
                    <div
                      className="sbi-search-icon align-items-center justify-content-center"
                      onClick={() => setDisplaySearchOnMobile(true)}
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.5 17.5L13.875 13.875"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  ) : (
                    <div
                      className="sbi-close-icon align-items-center justify-content-center"
                      onClick={() => setDisplaySearchOnMobile(false)}
                    >
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.8477 1.23047L1.84766 13.2305"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M1.84766 1.23047L13.8477 13.2305"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                </div>
                <div
                  className={`header-right  d-flex align-items-center flex-grow-1 ${
                    displaySearchOnMobile ? "header-right-new" : ""
                  }`}
                >
                  <Dropdown
                    className="header-search-box flex-grow-1 ms-auto dropdown position-static "
                    style={{ marginRight: "10px" }}
                  >
                    <Dropdown.Toggle
                      as={"div"}
                      className="header-search-box d-flex align-items-center flex-grow-1 ms-auto dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="M9.20475 15.8333C12.8867 15.8333 15.8714 12.8486 15.8714 9.16667C15.8714 5.48477 12.8867 2.5 9.20475 2.5C5.52285 2.5 2.53809 5.48477 2.53809 9.16667C2.53809 12.8486 5.52285 15.8333 9.20475 15.8333Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17.5381 17.5L13.9131 13.875"
                            stroke-width="1.5"
                            stroke="white"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </svg>
                      <input
                        type="text"
                        className="search-input"
                        placeholder={width < 574 ? "Search Commercial Products" : "Search Commercial Products for Sale"}
                        onChange={onChangeInput}
                        onKeyDown={(k) => {
                          if (k.key === "Enter") {
                            navigate(`/search/?q=${querydata}`);
                            setShowSearch(false);
                          }
                        }}
                      />
                    </Dropdown.Toggle>
                    {showSearch && <SearchFlyer facets={facets} querydata={querydata} />}
                  </Dropdown>
                  {!member ? (
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        typeof window !== "undefined" &&
                          window.localStorage.setItem("redirectUrl", window.location.href);
                        navigate("/members/login/");
                      }}
                      className="header-btn d-none d-xl-block  header-new-btn"
                    >
                      Login / Signup
                    </a>
                  ) : (
                    <Link to="/members/post-listing/" className="header-btn d-none d-xl-block  header-new-btn">
                      + Post a Listing
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </nav>
        </div>
        {member ? (
          <div className="header-dashboard d-flex align-items-center d-none d-xl-block">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="hd-container d-flex justify-content-between align-items-center">
                    <>
                      <div className="hd-left d-flex laign-items-center justify-content-start " style={{ gap: "5px" }}>
                        <div className="hd-text">Welcome, {member?.name01}</div>
                        <div className="hd-text credit-display" style={{ color: "gray" }}>
                          |
                        </div>
                        <div className="hd-text credit-display">
                          {" "}
                          Credit :&nbsp;
                          <span>
                            {!_.isEmpty(dashboardCount)
                              ? dashboardCount && dashboardCount.credit
                                ? "$" + numberFormat(dashboardCount.credit)
                                : "$0.00"
                              : "$0.00"}
                          </span>
                        </div>
                      </div>
                      <div className="hd-right">
                        <ul className="header-dashboard-nav navbar-nav flex-row">
                          <li className="nav-item header-dashboard-nav-item">
                            {/* <a href="#!" className="header-dashboard-nav-link nav-link-new">
                          Dashboard
                        </a> */}
                            <Link to="/my-account/dashboard" className="header-dashboard-nav-link nav-link-new">
                              <span>Dashboard</span>
                            </Link>
                          </li>
                          <li className="nav-item header-dashboard-nav-item dropdown">
                            <Link className="header-dashboard-nav-link nav-link-new" to="/my-account/my-profile">
                              My Account
                            </Link>
                            <ul className="dropdown-menu">
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/my-profile">
                                  <span>My Profile</span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/verification">
                                  <span>Verification</span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/payment-info">
                                  <span>Payment Info</span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/category-preferences">
                                  <span>Category Preferences</span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/region-preferences">
                                  <span>Region Preferences</span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/manufacturer-preferences">
                                  <span>Manufacturer Preferences</span>
                                </Link>
                              </li>

                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/change-password">
                                  <span>Change Password</span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/ncnda-list">
                                  <span>NCNDA</span>
                                </Link>
                              </li>
                              {dashboardCount?.inspectionCount > 0 ? (
                                <li className="dropdown-item">
                                  <Link className="brand-hover" to="/my-account/invoices">
                                    <span>Auth to Pay {`(${dashboardCount?.inspectionCount})`}</span>
                                  </Link>
                                </li>
                              ) : (
                                ""
                              )}
                              {/* {this.state.profileData?.unsubscribe ?
                                            <li>
                                              <a
                                                href="javascript:void(0)"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  navigate("/members/resubscribe", {
                                                    state: {},
                                                  });
                                                }}
                                              >
                                                <span
                                                  className={`main-dashboard-sidebar-child-button ${
                                                    this.props.page === "ncnda" && "active main-dashboard-sidebar-child-selected-button"
                                                  }`}
                                                >
                                                  Subscribe
                                                </span>
                                              </a>
                                            </li>:""} */}
                            </ul>
                          </li>
                          <li className="nav-item header-dashboard-nav-item dropdown">
                            <Link className="header-dashboard-nav-link nav-link-new" to="/my-account/business-units">
                              Company
                            </Link>
                            <ul className="dropdown-menu">
                              <li>
                                <Link to="/my-account/business-units" className="dropdown-item brand-hover" href="#">
                                  Business Units
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li className="nav-item header-dashboard-nav-item dropdown">
                            <Link
                              className="header-dashboard-nav-link nav-link-new"
                              to="/my-account/pending-and-redeployment"
                            >
                              Selling
                            </Link>
                            <ul className="dropdown-menu">
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/pending-and-redeployment">
                                  <span>
                                    {" "}
                                    Pending (
                                    {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.pending
                                      ? dashboardCount.myBu.pending
                                      : "0"}
                                    )
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/active-listings">
                                  <span>
                                    Active (
                                    {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.active
                                      ? dashboardCount.myBu.active
                                      : "0"}
                                    )
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/invoiced">
                                  <span>
                                    Invoiced (
                                    {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.invoiced
                                      ? dashboardCount.myBu.invoiced
                                      : "0"}
                                    )
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/archive">
                                  <span>
                                    Archived (
                                    {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.archive
                                      ? dashboardCount.myBu.archive
                                      : "0"}
                                    )
                                  </span>
                                </Link>
                              </li>

                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/my-sold-listings">
                                  <span>
                                    {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.success
                                      ? dashboardCount.successRate.success
                                      : "0"}
                                    /
                                    {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.total
                                      ? dashboardCount.successRate.total
                                      : "0"}
                                    &nbsp; sold&nbsp;
                                    {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.rate
                                      ? (
                                          parseFloat(
                                            dashboardCount.successRate.success / dashboardCount.successRate.total,
                                          ) * 100
                                        ).toFixed(2) + "%"
                                      : "0%"}
                                    &nbsp; success&nbsp;
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/my-buyers">
                                  <span>
                                    My Buyers (
                                    {dashboardCount && dashboardCount.buyerCount ? dashboardCount.buyerCount : 0})
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/seller-listing-agreements">
                                  <span>
                                    Listing Agreements (
                                    {dashboardCount && dashboardCount.listingAgreement
                                      ? dashboardCount.listingAgreement
                                      : 0}
                                    )
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <a
                                  className="brand-hover"
                                  href="/my-account/seller-asset-recovery-report"
                                  target="_blank"
                                >
                                  <span>Asset Recovery Report</span>
                                </a>
                              </li>
                              <li className="dropdown-item">
                                <a className="brand-hover" href="/members/post-listing">
                                  <span>Create New Listing</span>
                                </a>
                              </li>
                              {dashboardCount?.myActiveListings > 0 && member?.cid >= 1 && (
                                <li className="dropdown-item">
                                  <Link className="brand-hover" to="/my-account/redeploy-assets">
                                    <span>Redeploy Assets</span>
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>
                          <li className="nav-item header-dashboard-nav-item dropdown">
                            <Link className="header-dashboard-nav-link nav-link-new" to="/my-account/current-bids">
                              Buying
                            </Link>
                            <ul className="dropdown-menu">
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/current-bids">
                                  <span>
                                    Current Bids ({dashboardCount && dashboardCount.myBids ? dashboardCount.myBids : 0})
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/watchlist">
                                  <span>
                                    Watchlist (
                                    {dashboardCount && dashboardCount.watchListCount
                                      ? dashboardCount.watchListCount
                                      : 0}
                                    )
                                  </span>
                                </Link>
                              </li>

                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/invoices">
                                  <span>
                                    Invoices (
                                    {dashboardCount && dashboardCount.totalInvoice ? dashboardCount.totalInvoice : 0})
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/my-questions">
                                  <span>
                                    My Questions (
                                    {dashboardCount && dashboardCount.totalQuestion ? dashboardCount.totalQuestion : 0})
                                  </span>
                                </Link>
                              </li>

                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/rfq">
                                  <span>
                                    RFQ ({dashboardCount && dashboardCount.rfqRequest ? dashboardCount.rfqRequest : 0})
                                  </span>
                                </Link>
                              </li>
                              <li className="dropdown-item">
                                <Link className="brand-hover" to="/my-account/procurement-requests">
                                  <span>
                                    Procurement Requests (
                                    {dashboardCount && dashboardCount.procurementRequest
                                      ? dashboardCount.procurementRequest
                                      : 0}
                                    )
                                  </span>
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li className="nav-item header-dashboard-nav-item">
                            <Link
                              to="/my-account/listing-referrals/"
                              className="header-dashboard-nav-link nav-link-new"
                            >
                              Listing Referrals (
                              {dashboardCount && dashboardCount.buyerActivityCount
                                ? dashboardCount.buyerActivityCount
                                : 0}
                              )
                            </Link>
                          </li>

                          {typeof window !== "undefined" &&
                            localStorage.getItem("member") &&
                            JSON.parse(localStorage.getItem("member")).sec_list == 100103 &&
                            !localStorage.getItem("mimictoken") && (
                              <li className="nav-item header-dashboard-nav-item">
                                <Link to="/my-account/mimic-user/" className="header-dashboard-nav-link nav-link-new">
                                  Mimic User
                                </Link>
                              </li>
                            )}
                          <li className="nav-item header-dashboard-nav-item">
                            <a
                              href="javascrip:void(0)"
                              className="header-dashboard-nav-link nav-link-new"
                              onClick={onLogOut}
                            >
                              Logout
                            </a>
                          </li>
                        </ul>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}{" "}
        {member ? (
          <div className="header-dashboard nl-header-dashboard d-flex align-items-center d-xl-none ">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                  <div className="hd-container d-flex justify-content-between align-items-center w-100">
                    <>
                      <div className="hd-left d-flex align-items-center justify-content-between w-100 ">
                        <div className="d-flex align-items-center justify-content-start" style={{ gap: "5px" }}>
                          <div className="hd-text">Welcome, {member?.name01}</div>{" "}
                          <div className="hd-text credit-display" style={{ color: "gray" }}>
                            |
                          </div>{" "}
                          <div className="hd-text credit-display">
                            {" "}
                            Credit :&nbsp;
                            <span>
                              {!_.isEmpty(dashboardCount)
                                ? dashboardCount && dashboardCount.credit
                                  ? "$" + numberFormat(dashboardCount.credit)
                                  : "$0.00"
                                : "$0.00"}
                            </span>
                          </div>
                        </div>
                        <div className="hd-right">
                          <ul
                            className={`${styles.headerNavList} header-nav-list ms-auto d-flex align-items-center d-xl-none`}
                          >
                            {typeof window !== "undefined" && (
                              <>
                                {" "}
                                {window.localStorage.getItem("token") ? (
                                  <>
                                    <li className="htc-nav-item position-relative">
                                      <a
                                        href="javascript:void(0)"
                                        class={`${styles.htcNavLink} htc-nav-link add-to-cart`}
                                        data-bs-toggle="modal"
                                        data-bs-target="#chatCollapse"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          toggleHelp();
                                        }}
                                      >
                                        {" "}
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                            stroke="white"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M9.09009 9.00008C9.32519 8.33175 9.78924 7.76819 10.4 7.40921C11.0108 7.05024 11.729 6.91902 12.4273 7.03879C13.1255 7.15857 13.7589 7.52161 14.2152 8.06361C14.6714 8.60561 14.9211 9.2916 14.9201 10.0001C14.9201 12.0001 11.9201 13.0001 11.9201 13.0001"
                                            stroke="white"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M12 17H12.01"
                                            stroke="white"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </a>
                                    </li>
                                    {member?.sec_list != 1001031 && (
                                      <>
                                        {window.location.pathname === "/chats" ||
                                        window.location.pathname === "/chats/" ? (
                                          <li class="htc-nav-item position-relative">
                                            <a
                                              href="javascript:void(0)"
                                              class={`${styles.htcNavLink} htc-nav-link`}
                                              data-bs-toggle="modal"
                                              data-bs-target="#chatCollapse"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                //this.setState({ chatNotification: false });
                                                navigate("/chats");
                                              }}
                                            >
                                              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                  d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke={"white"}
                                                ></path>
                                              </svg>
                                              {unreadCount > 0 ? <span class="chats-numbers">{unreadCount}</span> : ""}
                                            </a>
                                          </li>
                                        ) : (
                                          <ChatIcon isMobile={true} unReadChatCount={unreadCount} />
                                        )}
                                      </>
                                    )}
                                    <li class="htc-nav-item position-relative">
                                      {
                                        <a
                                          href="javascript:void(0)"
                                          class={`${styles.htcNavLink} htc-nav-link add-to-cart`}
                                          data-bs-toggle="modal"
                                          data-bs-target="#chatCollapse"
                                          onClick={(e) => {
                                            e.preventDefault();

                                            navigate("/my-account/watchlist");
                                          }}
                                        >
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clip-path="url(#clip0_5571_58128)">
                                              <path
                                                d="M7.50001 18.3334C7.96024 18.3334 8.33334 17.9603 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9603 7.03977 18.3334 7.50001 18.3334Z"
                                                stroke={"white"}
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M16.6667 18.3334C17.1269 18.3334 17.5 17.9603 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9603 16.2064 18.3334 16.6667 18.3334Z"
                                                stroke={"white"}
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M0.833344 0.833313H4.16668L6.40001 11.9916C6.47621 12.3753 6.68493 12.7199 6.98963 12.9652C7.29433 13.2105 7.67559 13.3408 8.06668 13.3333H16.1667C16.5578 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.7199 17.7571 12.3753 17.8333 11.9916L19.1667 4.99998H5.00001"
                                                stroke={"white"}
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_5571_58128">
                                                <rect width="20" height="20" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          {dashboardCount?.watchListCount > 0 ? (
                                            <span class="cart-numbers">{dashboardCount?.watchListCount}</span>
                                          ) : (
                                            ""
                                          )}
                                        </a>
                                      }
                                    </li>

                                    <li class="htc-nav-item htc-nav-item-last">
                                      <a
                                        href="javascript:void(0)"
                                        className={` hnl-link my-account-text ${styles.myAccountText}`}
                                        data-bs-toggle="modal"
                                        data-bs-target="#profileCollapse"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          navigate(
                                            typeof window !== "undefined" && window.localStorage.getItem("token")
                                              ? "/my-account/dashboard"
                                              : "/members/login",
                                          );
                                        }}
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                            stroke={"white"}
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                                            stroke={"white"}
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                        {typeof window !== "undefined" && window.localStorage.getItem("token")
                                          ? ""
                                          : "Login"}
                                      </a>
                                    </li>
                                  </>
                                ) : (
                                  <li class="htc-nav-item ">
                                    <a
                                      href="javascript:void(0)"
                                      className={` hnl-link my-account-text ${styles.myAccountText}`}
                                      data-bs-toggle="modal"
                                      data-bs-target="#profileCollapse"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        // typeof window !== "undefined" &&
                                        //   window.localStorage.setItem("redirectUrl", urlLocation);
                                        navigate(
                                          typeof window !== "undefined" && window.localStorage.getItem("token")
                                            ? "/my-account/dashboard"
                                            : "/members/login",
                                        );
                                      }}
                                    >
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                          stroke={"white"}
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                                          stroke={
                                            customizedDashboard?.is_logo_white
                                              ? customizedDashboard?.dashboard_color
                                              : "white"
                                          }
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      {typeof window !== "undefined" && window.localStorage.getItem("token")
                                        ? "My Account"
                                        : "Login"}
                                    </a>
                                  </li>
                                )}
                              </>
                            )}
                          </ul>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="header-dashboard nl-header-dashboard d-flex align-items-center d-xl-none ">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12" style={{ paddingLeft: "0px" }}>
                  <div className="hd-container d-flex justify-content-between align-items-center w-100">
                    <>
                      <div className="hd-left d-flex align-items-center justify-content-end w-100 ">
                        <div className="hd-text">
                          <a
                            style={{ textDecoration: "underline" }}
                            href="javascript:void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              typeof window !== "undefined" &&
                                window.localStorage.setItem("redirectUrl", window.location.href);
                              navigate("/members/login/");
                            }}
                          >
                            Login / Signup
                          </a>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>

      <DashboardSideBar show={showSideBar} onHide={toggleSideBar} dashboardCount={dashboardCount} onLogOut={onLogOut} />

      {showNCNDA && <NCNDAModal show={showNCNDA} onHide={toggleNCNDA} />}
      <Help show={showHelp} onHide={toggleHelp} />
    </>
  );
};

export default Header;
